module.exports = __webpack_public_path__ + "static/media/beautiful-&-simple.4218ad92.jpg";